var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditBtn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_760_17331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 3.3332H5.66675C4.26662 3.3332 3.56655 3.3332 3.03177 3.60568C2.56137 3.84536 2.17892 4.22782 1.93923 4.69822C1.66675 5.233 1.66675 5.93307 1.66675 7.3332V14.3332C1.66675 15.7333 1.66675 16.4334 1.93923 16.9682C2.17892 17.4386 2.56137 17.821 3.03177 18.0607C3.56655 18.3332 4.26662 18.3332 5.66675 18.3332H12.6667C14.0669 18.3332 14.7669 18.3332 15.3017 18.0607C15.7721 17.821 16.1546 17.4386 16.3943 16.9682C16.6667 16.4334 16.6667 15.7333 16.6667 14.3332V10.8332M6.66673 13.3332H8.06218C8.46983 13.3332 8.67366 13.3332 8.86547 13.2871C9.03553 13.2463 9.1981 13.179 9.34722 13.0876C9.51542 12.9845 9.65954 12.8404 9.9478 12.5521L17.9167 4.5832C18.6071 3.89284 18.6071 2.77355 17.9167 2.0832C17.2264 1.39284 16.1071 1.39284 15.4167 2.0832L7.44778 10.0521C7.15952 10.3404 7.0154 10.4845 6.91233 10.6527C6.82094 10.8018 6.7536 10.9644 6.71278 11.1345C6.66673 11.3263 6.66673 11.5301 6.66673 11.9378V13.3332Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_760_17331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBtn);
export default __webpack_public_path__ + "static/media/edit_btn.e10e3dd65d0574154005c0fac4afa6ed.svg";
export { ForwardRef as ReactComponent };